import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * ReadOnlyModeBadge (2026-02-18)
 *
 * Wyświetlany dla użytkowników z `role="viewer"`. Klik otwiera krótkie
 * wyjaśnienie. Nie ma logiki blokującej — źródłem prawdy jest backend
 * (`services/access_guard.py` → HTTP 403 z code `production_viewer_read_only`).
 *
 * NIE wyświetlany:
 *   - administratorom (owner/accountant/employee),
 *   - użytkownikom niezalogowanym.
 */
const ReadOnlyModeBadge = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  const role = (user?.role || "").toLowerCase().trim();
  const isViewer = role === "viewer";

  if (!user || !isViewer) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-900 ring-1 ring-inset ring-amber-500/40 hover:bg-amber-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-600"
        data-testid="read-only-mode-badge"
        aria-label="Tryb tylko do odczytu"
      >
        <span aria-hidden="true">👁️</span>
        Tryb tylko do odczytu
      </button>
      {open && (
        <div
          className="absolute right-4 top-14 z-50 w-80 rounded-lg bg-white p-4 text-sm text-slate-700 shadow-xl ring-1 ring-slate-200"
          data-testid="read-only-mode-info"
        >
          <p className="font-medium text-slate-900">
            To konto może wyłącznie przeglądać dane.
          </p>
          <p className="mt-2 leading-relaxed text-slate-600">
            Konto działa w trybie demonstracyjnym. Wszelkie operacje zmieniające
            dane (import, analiza, eksport, tworzenie paczek) są zablokowane
            na produkcji. Skontaktuj się z administratorem, aby otrzymać
            pełen dostęp.
          </p>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="mt-3 text-xs font-medium text-slate-500 underline underline-offset-2 hover:text-slate-700"
            data-testid="read-only-mode-close-btn"
          >
            Zamknij
          </button>
        </div>
      )}
    </>
  );
};

export default ReadOnlyModeBadge;
